import "./style.scss";

import { createApp, type App } from "vue";

import { getAdminEmail } from "./elements/admin";

import Client from "./Client.vue";

const WC_STORE = "wc/store/cart" as const;
const SHIPPING_METHOD_ID = "innosend" as const;

interface ShippingRate {
	method_id: string;
	rate_id: string;
	name: string;
	price: string;
	chosen: boolean;
	description?: string;
	taxes?: string;
}

let app: App;

const events = ["updated_checkout", "cart_page_refreshed"];

function init() {
	try {
		// Check if WP data is available and shipping method is selected
		if (window.wp?.data) {
			const shippingRates = window.wp.data
				.select(WC_STORE)
				.getShippingRates()[0]
				?.shipping_rates.filter(({ method_id }: ShippingRate) => method_id === SHIPPING_METHOD_ID);

			// Only proceed if our shipping method is selected
			if (!shippingRates?.[0]?.selected) {
				// Unmount the app if our shipping method is not selected
				if (app) {
					app.unmount();
				}
				return;
			}
		}

		const appElement = document.getElementById("innosend");
		if (!appElement) return;

		if (app) {
			app.unmount();
		}

		app = createApp(Client);
		app.mount("#innosend");
	} catch (error) {
		// If WP data is not available, try to init anyway
		const appElement = document.getElementById("innosend");
		if (!appElement) return;

		if (app) {
			app.unmount();
		}

		app = createApp(Client);
		app.mount("#innosend");
	}
}

const observer = new MutationObserver((mutations, obs) => {
	const element = document.getElementById("innosend");
	if (element) {
		init();
		obs.disconnect();
	}
});

if (!document.getElementById("innosend")) {
	observer.observe(document.body, { childList: true, subtree: true });
} else {
	init();
}

document.addEventListener("DOMContentLoaded", () => {
	init();
	events.forEach((event) => jQuery(document.body).on(event, init));
});

// Add subscription to shipping rate changes
if (window.wp?.data) {
	window.wp.data.subscribe(() => {
		const shippingRates = window.wp.data.select(WC_STORE).getShippingRates()[0]?.shipping_rates;
		if (shippingRates) {
			init();
		}
	});
}

getAdminEmail();
